export const qqModal = () => {
    const modalTriggers = document.querySelectorAll('.quick-quote__modal-trigger');
    const modal = document.querySelector('.triggered-qq-modal');
    const qqContainer = document.querySelector('.modal--qq');
    modalTriggers.forEach((el) => {
        el.addEventListener('click', function () {
            modal.classList.toggle('hidden');
            if (!modal.classList.contains('hidden')) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = '';
            }
        });
    });
    document
        .querySelector('.qq-modal__close-btn')
        .addEventListener('click', (event) => {
        modal.classList.add('hidden');
        if (!modal.classList.contains('hidden')) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
    });
};
